import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22page.tsx%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:%22../../public/fonts/hanachi.ttf%22}],%22variableName%22:%22font%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'__font_7dddc2', '__font_Fallback_7dddc2'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
        